
<div class="t-popup popup-patientDetails">

    <div class="t-popup-close"></div>
    
    <div   class="t-popup-frame maxw" *ngIf="gfs.typeForm != 'Form of Consent'">
        <app-admission  *ngIf="gfs.typeForm == 'Admission Form'" (closed)="close(true)" (print)="showprint=true;showprintopts=true"></app-admission>
        <app-timeout *ngIf="gfs.typeForm == 'Time Out Form'" (closed)="close(true)" (print)="showprint=true;showprintopts=true"></app-timeout>
        <app-recovery  *ngIf="gfs.typeForm == 'Recovery Form'" (closed)="close(true)" (print)="showprint=true;showprintopts=true"></app-recovery>
        <app-release *ngIf="gfs.typeForm == 'Release Form'" (closed)="close(true)" (print)="showprint=true;showprintopts=true"></app-release>
        <app-gastro-procedure *ngIf="gfs.typeForm == 'Course Of Exam'" (closed)="close(true)" (print)="showprint=true;showprintopts=true"></app-gastro-procedure>
        
    </div>
    <div *ngIf="gfs.typeForm == 'Form of Consent'" class="t-popup-frame maxw" style="width: 60%;">
    <app-consent-form (closed)="close(true)" (print)="showprint=true;showprintopts=true"></app-consent-form>

    </div>
</div>

<app-gastro-printopts *ngIf="showprint" (closed)="showprint=false" [showopts]="showprintopts"></app-gastro-printopts>